function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from 'react';
import { ContextActions } from '@deephaven/components';
import { getWorkspace, setWorkspace as setWorkspaceAction } from '@deephaven/redux';
import { connect } from 'react-redux';
import { LayoutUtils } from "./layout/index.js";
import { PanelEvent } from "./PanelEvent.js";
import { jsx as _jsx } from "react/jsx-runtime";
class PanelContextMenu extends PureComponent {
  constructor(props) {
    super(props);
    this.handleCloseTab = this.handleCloseTab.bind(this);
    this.handleCloseTabsRight = this.handleCloseTabsRight.bind(this);
    this.handleCloseTabsAll = this.handleCloseTabsAll.bind(this);
    this.handleReopenLast = this.handleReopenLast.bind(this);
  }
  getAllTabs() {
    var _glContainer$tab$head, _glContainer$tab;
    // return a clone of the tabs array, or returns empty array if null
    var glContainer = this.props.glContainer;
    return [...((_glContainer$tab$head = glContainer === null || glContainer === void 0 || (_glContainer$tab = glContainer.tab) === null || _glContainer$tab === void 0 || (_glContainer$tab = _glContainer$tab.header) === null || _glContainer$tab === void 0 ? void 0 : _glContainer$tab.tabs) !== null && _glContainer$tab$head !== void 0 ? _glContainer$tab$head : [])];
  }
  handleCloseTab() {
    var glContainer = this.props.glContainer;
    glContainer.close();
  }
  handleCloseTabsAll() {
    var tabs = this.getAllTabs();

    // No need to check if isClosable, golden-layout returns
    // false when attempting to close tabs that you can't
    tabs.forEach(tab => {
      var _container;
      return (_container = (tab === null || tab === void 0 ? void 0 : tab.contentItem).container) === null || _container === void 0 ? void 0 : _container.close();
    });
  }
  handleCloseTabsRight() {
    var glContainer = this.props.glContainer;
    var tabs = this.getAllTabs();
    for (var i = tabs.length - 1; i > 0; i -= 1) {
      var _tabs$i$contentItem, _glContainer$tab2, _container2, _tabs$i;
      if (((_tabs$i$contentItem = tabs[i].contentItem) === null || _tabs$i$contentItem === void 0 || (_tabs$i$contentItem = _tabs$i$contentItem.config) === null || _tabs$i$contentItem === void 0 ? void 0 : _tabs$i$contentItem.id) === ((_glContainer$tab2 = glContainer.tab) === null || _glContainer$tab2 === void 0 || (_glContainer$tab2 = _glContainer$tab2.contentItem) === null || _glContainer$tab2 === void 0 || (_glContainer$tab2 = _glContainer$tab2.config) === null || _glContainer$tab2 === void 0 ? void 0 : _glContainer$tab2.id)) {
        break; // end when we get back to current id
      }

      // eslint-disable-next-line no-unused-expressions
      (_container2 = ((_tabs$i = tabs[i]) === null || _tabs$i === void 0 ? void 0 : _tabs$i.contentItem).container) === null || _container2 === void 0 || _container2.close();
    }
  }
  handleReopenLast() {
    var _this$props = this.props,
      glContainer = _this$props.glContainer,
      glEventHub = _this$props.glEventHub;
    glEventHub.emit(PanelEvent.REOPEN_LAST, glContainer);
  }
  canCloseTabsRight() {
    var glContainer = this.props.glContainer;
    var tabs = this.getAllTabs();
    var disabled = true;
    for (var i = tabs.length - 1; i > 0; i -= 1) {
      var _tabs$i$contentItem2, _glContainer$tab3, _tabs$i2;
      if (((_tabs$i$contentItem2 = tabs[i].contentItem) === null || _tabs$i$contentItem2 === void 0 || (_tabs$i$contentItem2 = _tabs$i$contentItem2.config) === null || _tabs$i$contentItem2 === void 0 ? void 0 : _tabs$i$contentItem2.id) === ((_glContainer$tab3 = glContainer.tab) === null || _glContainer$tab3 === void 0 || (_glContainer$tab3 = _glContainer$tab3.contentItem) === null || _glContainer$tab3 === void 0 || (_glContainer$tab3 = _glContainer$tab3.config) === null || _glContainer$tab3 === void 0 ? void 0 : _glContainer$tab3.id)) {
        break; // end when we get back to current id
      }
      var closable = Boolean((_tabs$i2 = tabs[i]) === null || _tabs$i2 === void 0 || (_tabs$i2 = _tabs$i2.contentItem) === null || _tabs$i2 === void 0 || (_tabs$i2 = _tabs$i2.config) === null || _tabs$i2 === void 0 ? void 0 : _tabs$i2.isClosable);
      if (closable) {
        disabled = false;
        break; // end if we find a closeable tab
      }
    }
    return disabled;
  }
  canCloseAny() {
    var tabs = this.getAllTabs();
    var disabled = true;
    for (var i = tabs.length - 1; i > 0; i -= 1) {
      var _tabs$i3;
      var closable = Boolean((_tabs$i3 = tabs[i]) === null || _tabs$i3 === void 0 || (_tabs$i3 = _tabs$i3.contentItem) === null || _tabs$i3 === void 0 || (_tabs$i3 = _tabs$i3.config) === null || _tabs$i3 === void 0 ? void 0 : _tabs$i3.isClosable);
      if (closable) {
        disabled = false;
        break;
      }
    }
    return disabled;
  }
  canReopenLast() {
    var _LayoutUtils$getStack, _workspace$data$close;
    var _this$props2 = this.props,
      workspace = _this$props2.workspace,
      glContainer = _this$props2.glContainer;
    var stackId = (_LayoutUtils$getStack = LayoutUtils.getStackForConfig(glContainer.layoutManager.root, glContainer.getConfig())) === null || _LayoutUtils$getStack === void 0 ? void 0 : _LayoutUtils$getStack.config.id;
    return !((_workspace$data$close = workspace.data.closed) !== null && _workspace$data$close !== void 0 && _workspace$data$close.some(panel => panel.parentStackId === stackId));
  }
  render() {
    var _glContainer$tab4;
    var _this$props3 = this.props,
      additionalActions = _this$props3.additionalActions,
      glContainer = _this$props3.glContainer;
    var contextActions = [...additionalActions];
    contextActions.push(() => ({
      title: 'Re-open closed panel',
      group: ContextActions.groups.medium + 2004,
      action: this.handleReopenLast,
      disabled: this.canReopenLast()
    }));
    var closable = (_glContainer$tab4 = glContainer.tab) === null || _glContainer$tab4 === void 0 || (_glContainer$tab4 = _glContainer$tab4.contentItem) === null || _glContainer$tab4 === void 0 || (_glContainer$tab4 = _glContainer$tab4.config) === null || _glContainer$tab4 === void 0 ? void 0 : _glContainer$tab4.isClosable;
    contextActions.push({
      title: 'Close',
      order: 10,
      group: ContextActions.groups.low,
      action: this.handleCloseTab,
      disabled: closable === undefined || !closable
    });

    // pushed as function so the disable check happens on run
    contextActions.push(() => ({
      title: 'Close Tabs to Right',
      order: 20,
      group: ContextActions.groups.low,
      action: this.handleCloseTabsRight,
      disabled: this.canCloseTabsRight()
    }));
    contextActions.push(() => ({
      title: 'Close All',
      order: 30,
      group: ContextActions.groups.low,
      action: this.handleCloseTabsAll,
      disabled: this.canCloseAny()
    }));
    return /*#__PURE__*/_jsx(ContextActions, {
      actions: contextActions
    });
  }
}
_defineProperty(PanelContextMenu, "defaultProps", {
  additionalActions: []
});
var mapStateToProps = state => ({
  workspace: getWorkspace(state)
});
var ConnectedPanelContextMenu = connect(mapStateToProps, {
  setWorkspace: setWorkspaceAction
})(PanelContextMenu);
export default ConnectedPanelContextMenu;
//# sourceMappingURL=PanelContextMenu.js.map